import { Eyebrow } from "./Eyebrow";
import { GridPattern } from "./GridPattern";

const STEPS = [
  {
    n: "01",
    title: "Aplicação",
    desc: "Você preenche o formulário e nosso time entra em contato em até 1 dia útil para uma conversa de qualificação mútua.",
  },
  {
    n: "02",
    title: "Reunião 1:1",
    desc: "Apresentamos o produto, a estrutura institucional, o modelo de remuneração e respondemos qualquer pergunta técnica.",
  },
  {
    n: "03",
    title: "Onboarding e credenciamento",
    desc: "Você recebe os materiais, acesso ao painel do parceiro e o treinamento de produto. Tudo formalizado em contrato.",
  },
  {
    n: "04",
    title: "Divulgação",
    desc: "Você apresenta a oportunidade aos seus clientes. O cadastro do investidor e a liquidação acontecem dentro da plataforma regulada (Dexcap, CVM).",
  },
];

export const ParceirosComoFunciona = () => {
  return (
    <section
      id="como-funciona"
      className="bg-white border-y border-zinc-200 py-16 sm:py-20 md:py-24 relative overflow-hidden"
    >
      <GridPattern />
      <div className="container-narrow relative">
        <div>
          <div className="flex justify-center mb-4">
            <Eyebrow>Como é a parceria</Eyebrow>
          </div>
          <h2
            className="text-center font-bold leading-[1.1] tracking-tight text-[#323F4F] text-3xl sm:text-4xl md:text-5xl mt-6"
            style={{
              fontFamily:
                '"Plus Jakarta Sans", Inter, system-ui, sans-serif',
              letterSpacing: "-0.02em",
            }}
          >
            Quatro passos <span className="text-[#2E694D]">simples</span>:
          </h2>
        </div>

        <div className="mt-12 sm:mt-14 space-y-3 sm:space-y-4">
          {STEPS.map((step) => (
            <div key={step.n}>
              <div className="bg-[#F8F8F7] border border-zinc-200 rounded-2xl p-6 sm:p-7 hover:border-zinc-300 transition-colors">
                <div className="flex items-start gap-5 sm:gap-7">
                  <div
                    className="text-3xl sm:text-4xl font-bold flex-shrink-0 leading-none text-[#2E694D]"
                    style={{
                      fontFamily:
                        '"Plus Jakarta Sans", Inter, system-ui, sans-serif',
                    }}
                  >
                    {step.n}
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg sm:text-xl font-semibold text-[#323F4F] tracking-tight">
                      {step.title}
                    </h3>
                    <p className="mt-2 text-sm sm:text-base text-zinc-600 leading-relaxed">
                      {step.desc}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
